import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {OrderAssignmentRuleSearchModel} from "../order-assignment-rule-search.model";
import {OrderAssignmentRuleEntityModel} from "../order-assignment-rule-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-order-assignment-rule-search-page",
    templateUrl: "./order-assignment-rule-search-page.component.html",
    providers: [provideSearchModel(OrderAssignmentRuleSearchModel), provideEntityModel(OrderAssignmentRuleEntityModel)]
})
export class OrderAssignmentRuleSearchPageComponent extends AbstractSearchPage {
}
